<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconArrowLeftRegular_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="m4.29 12.707 4.953 5a.983.983 0 0 0 1.4 0 1.005 1.005 0 0 0 0-1.414l-3.196-3.227h11.55c.554 0 1.003-.454 1.003-1.013 0-.56-.45-1.014-1.004-1.014H7.343l3.3-3.332a1.005 1.005 0 0 0 0-1.414.983.983 0 0 0-1.4 0l-4.953 5a1.005 1.005 0 0 0 0 1.414"
        clip-rule="evenodd"
    />
</svg>
